import { List } from 'immutable';
import { createReducer } from '@reduxjs/toolkit';

import * as actions from './actions';
import { Subscription } from '../../records/Subscription';

export interface State {
  readonly elements: List<Subscription>
  readonly isLoading: boolean
  readonly autoRefillEnabled: boolean
}

const initialState: State = {
  elements: List<Subscription>(),
  autoRefillEnabled: false,
  isLoading: true,
};

export default createReducer(initialState, (builder) => {
  builder.addCase(actions.fetchSubscriptions.pending, (draft) => {
    draft.isLoading = true;
  });
  builder.addCase(actions.fetchSubscriptions.fulfilled, (draft, { payload }) => {
    draft.elements = List(payload.data.map((sub) => Subscription.parseSubscription(sub)));
    draft.isLoading = false;
  });
  builder.addCase(actions.fetchSubscriptions.rejected, (draft) => {
    draft.isLoading = false;
    draft.elements = initialState.elements;
  });
  builder.addCase(actions.resetSubscriptionsReducer, (draft) => {
    draft.elements = initialState.elements;
    draft.isLoading = initialState.isLoading;
  });
  builder.addCase(actions.cancelSubscription.fulfilled, (draft, { payload }) => {
    const { elements } = draft;
    const subscription = Subscription.parseSubscription(payload.data);
    const index = elements.findIndex(
      (sub) => sub?.id === subscription.id);
    draft.elements = elements.set(index, subscription);
  });
  builder.addCase(actions.fetchAutoTopupStatus.fulfilled, (draft, { payload }) => {
    draft.autoRefillEnabled = payload.data.value;
  });
  builder.addCase(actions.updateAutoTopupStatus.fulfilled, (draft) => {
    draft.autoRefillEnabled = !draft.autoRefillEnabled;
  });
});
